export default __webpack_public_path__ + "assets/530a93f3f70e82a4d61eed595540b1ec.svg";